import { getCanonicalPath } from '@react/search/helpers';
import {
  RESOURCE_CENTER_AUTHOR_PATH,
  RESOURCE_CENTER_REVIEWER_PATH,
} from '@sly/core/constants/dashboardAppPaths';
import { DZComponentsNames } from '@sly/core/constants/dynamicZone';
import { generatePath } from 'react-router';

export const SENIOR_LIVING_GUIDES_TOPIC = 'senior-living-guides';
export const HEALTH_AND_LIFESTYLE_TOPIC = 'health-and-lifestyle';

export const ARTICLES_RANGE_FOR_PAGINATION = 18;
export const GUIDES_PER_PAGE = 3;
export const ARTICLES_PER_PAGE = 15;

export const selectAllArticlesItem = {
  value: 'all-articles',
  label: 'All articles',
};

export const seniorLivingGuidesTags = [
  selectAllArticlesItem,
  { value: 'assisted-living', label: 'Assisted living' },
  { value: 'independent-living', label: 'Independent living' },
  { value: 'memory-care', label: 'Memory care' },
  { value: 'ccrc', label: 'CCRC' },
  { value: 'home-care', label: 'Home care' },
  { value: 'finance', label: 'Finance' },
  { value: 'legal', label: 'Legal' },
  { value: 'advisors', label: 'Advisors' },
];

export const healthAndLifestyleTags = [
  selectAllArticlesItem,
  { value: 'lifestyle', label: 'Lifestyle' },
  { value: 'health', label: 'Health' },
  { value: 'technology', label: 'Technology' },
  { value: 'veterans', label: 'Veterans' },
  { value: 'travel', label: 'Travel' },
  { value: 'business', label: 'Business' },
];

export const getPaginationProperties = ({ current, count, basePath }) => {
  let start;
  let end;

  current = parseInt(current || 1, 10);
  const pageNumber = current - 1;

  if (pageNumber) {
    start = pageNumber * ARTICLES_RANGE_FOR_PAGINATION + 1;
  } else start = 1;
  if (
    count < ARTICLES_RANGE_FOR_PAGINATION ||
    pageNumber * ARTICLES_RANGE_FOR_PAGINATION +
      ARTICLES_RANGE_FOR_PAGINATION >=
      count
  ) {
    end = count;
  }
  if (
    pageNumber * ARTICLES_RANGE_FOR_PAGINATION + ARTICLES_RANGE_FOR_PAGINATION <
    count
  ) {
    end =
      pageNumber * ARTICLES_RANGE_FOR_PAGINATION +
      ARTICLES_RANGE_FOR_PAGINATION;
  }
  if (ARTICLES_RANGE_FOR_PAGINATION < count && !pageNumber) {
    end = ARTICLES_RANGE_FOR_PAGINATION;
  }
  const total = Math.ceil(count / ARTICLES_RANGE_FOR_PAGINATION);

  const [linkRel, filteredParams, rejectParams] = getCanonicalPath(
    basePath,
    {},
    current,
    total
  );

  return {
    basePath,
    start,
    end,
    count,
    total,
    current,
    linkRel,
    filteredParams,
    rejectParams,
  };
};

//TODO use library
export const getSearchItem = (search, itemName, fullString) => {
  if (!search) return null;
  const splitSearch = search.split('&');
  const splitSearchItem = splitSearch.find((item) => item.includes(itemName));
  if (splitSearchItem) {
    return fullString
      ? splitSearchItem.replace('?', '')
      : splitSearchItem.split('=')[1];
  }
  return null;
};

export const toUppercaseAndSnakeCase = (value) =>
  value?.toUpperCase().replace(/-/g, '_');

export const getTagsOptionByTopic = (topic) =>
  (topic === SENIOR_LIVING_GUIDES_TOPIC && seniorLivingGuidesTags) ||
  (topic === HEALTH_AND_LIFESTYLE_TOPIC && healthAndLifestyleTags);

export const getTagsSelectDefaultValue = (search, topic) => {
  const tagName = getSearchItem(search, 'tag-name');
  if (tagName) {
    const tagList = getTagsOptionByTopic(topic);
    const defaultValue = tagList.find((item) => item.value === tagName);
    if (defaultValue) {
      return defaultValue;
    }
  }
  return selectAllArticlesItem;
};

export const onChangeTagsSelect = (push, value, pathname) => {
  let tagNameSearchItem = '';
  if (value !== selectAllArticlesItem.value) {
    tagNameSearchItem = `?tag-name=${value}`;
  }

  try {
    push(pathname + tagNameSearchItem);
  } catch (err) {
    console.log(err);
  }
};

export const isActiveTab = (search, value) => {
  if (
    value === selectAllArticlesItem.value &&
    !getSearchItem(search, 'tag-name')
  )
    return true;
  return getSearchItem(search, 'tag-name') === value;
};

export const getStylesForEllipsisText = (maxRowQty, styles = {}) => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: maxRowQty,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  ...styles,
});

export const getArticleTopicRequestParams = (search, topic) => {
  const pageNumber = getSearchItem(search, 'page-number') || 1;

  return {
    'filters[$or][0][mainTopic][slug][$eq]': topic,
    'filters[$or][1][subTopics][slug][$contains]': topic,
    'pagination[page]': Number(pageNumber),
    'pagination[pageSize]': 18,
    sort: 'publishedAt:desc',
    populate: '*',
  };
};

export const getArticleTagsRequestParams = (query, tag) => {
  const pageNumber = query['page-number'] || 1;

  return {
    'filters[tagsSlug][$contains]': toUppercaseAndSnakeCase(tag),
    'pagination[page]': Number(pageNumber),
    'pagination[pageSize]': 18,
    sort: 'publishedAt:desc',
    populate: '*',
  };
};

export const getTopicRequestParams = (params) => {
  const { topic } = params;

  return {
    'filters[slug]': topic,
    populate: '*',
  };
};

export const getReviewerPath = (slug) => {
  return generatePath(RESOURCE_CENTER_REVIEWER_PATH, {
    slug: encodeURIComponent(slug),
  });
};

export const getAuthorPath = (slug) => {
  return generatePath(RESOURCE_CENTER_AUTHOR_PATH, {
    slug: encodeURIComponent(slug),
  });
};

export const getYoutubeLinksFromDynamicContent = (content) => {
  const result = [];
  content?.map((item) => {
    if (item.__component.includes(DZComponentsNames.youTubeVideoLink)) {
      result.push(item);
    }
  });
  return result;
};
